import { store } from 'app/shared/store/store';
import { StoreKeys } from 'app/shared/constants/store-keys.enum';
import { DataSpaKey } from 'app/shared/models/dataSpa';
import { getDataSpaSearchParams } from 'app/shared/utilities/helper-functions';
import { bundleService } from 'app/shared/services/bundle/bundle.service';

class BannerService {
  public getBannerTitle(dataSpa: string): string {
    let prefix = '';
    let spaBanner: string;
    if (dataSpa) {
      const spaParams = getDataSpaSearchParams(dataSpa);
      spaBanner = spaParams.get(DataSpaKey.banner);
    }
    const productCategory = store.get(StoreKeys.productCategory);
    const defaultBanner = productCategory === 'nbn' ? 'AGL internet plans' : 'AGL Mobile is here';
    if (bundleService.isExplicitBundleFlow()) {
      const bundleProductList = bundleService.getBundleConfig();
      const number = Array.from(bundleProductList.entries()).findIndex((bundle) => bundle[0] === productCategory) + 1;
      if (bundleProductList && number) {
        prefix = `Step ${number} • `;
      }
    }
    const banner = spaBanner && spaBanner !== '' ? spaBanner : defaultBanner;
    return `${prefix}${banner}`;
  }

  public toggleBanner(): void {
    const defaultBannerElem = document.querySelector('.headlinebanner')?.closest('section.container') as HTMLElement;
    const progressIndicatorElem = document
      .querySelector('[spa-id="app-banner-progress-indicator"]')
      ?.closest('section.container') as HTMLElement;
    const promoBannerElem = document.querySelector('[spa-id="app-promo-banner"]')?.closest('section.container') as HTMLElement;
    if (this.shouldShowPromoBanner()) {
      // Hide default banner and banner-progress-indicator
      this.toggleElementDisplay(defaultBannerElem, false);
      this.toggleElementDisplay(progressIndicatorElem, false);
      // Show promo banner
      this.toggleElementDisplay(promoBannerElem, true);
      promoBannerElem.classList.remove('vertical-padding-top');
    } else {
      // Show default banner and banner-progress-indicator
      this.toggleElementDisplay(defaultBannerElem, true);
      this.toggleElementDisplay(progressIndicatorElem, true);
      // Hide promo banner
      this.toggleElementDisplay(promoBannerElem, false);
    }
  }

  private shouldShowPromoBanner(): boolean {
    const promotionPage = store.get('promotionPage');
    const isPromoBannerValid =
      !!promotionPage?.promoBanner?.content && !!promotionPage?.promoBanner?.footer && !!promotionPage?.promoBanner?.imagePath;
    return promotionPage?.isPromoValid && isPromoBannerValid;
  }

  private toggleElementDisplay(element: HTMLElement, display: boolean): void {
    if (!element) {
      return;
    }
    element.style.display = display ? 'block' : 'none';
  }
}

export const bannerService = new BannerService();
